import { z } from "zod";
import { cursorPageSchema } from "./context.js";
/** A bounded, explicit workflow for operator follow-up work. */
export const evidenceTaskStateSchema = z.enum([
    "OPEN",
    "IN_PROGRESS",
    "BLOCKED",
    "DONE",
    "CANCELLED",
]);
export const evidenceTaskAssigneeSchema = z
    .object({
    id: z.string().uuid(),
    name: z.string().min(1),
})
    .strict();
const optionalUuid = z.string().uuid().nullable().optional();
const optionalDueDate = z.string().date().nullable().optional();
export const evidenceTaskCreateSchema = z
    .object({
    title: z.string().trim().min(1).max(200),
    description: z.string().trim().min(1).max(5_000),
    assigneeId: optionalUuid,
    dueDate: optionalDueDate,
    evidenceId: optionalUuid,
    sourceRunId: optionalUuid,
})
    .strict();
export const evidenceTaskPatchSchema = z
    .object({
    title: z.string().trim().min(1).max(200).optional(),
    description: z.string().trim().min(1).max(5_000).optional(),
    assigneeId: optionalUuid,
    dueDate: optionalDueDate,
    evidenceId: optionalUuid,
    sourceRunId: optionalUuid,
    state: evidenceTaskStateSchema.optional(),
})
    .strict()
    .superRefine((value, context) => {
    if (Object.keys(value).length === 0) {
        context.addIssue({ code: "custom", message: "At least one field is required" });
    }
});
export const evidenceTaskSchema = z
    .object({
    id: z.string().uuid(),
    title: z.string().min(1),
    description: z.string().min(1),
    state: evidenceTaskStateSchema,
    assignee: evidenceTaskAssigneeSchema.nullable(),
    dueDate: z.string().date().nullable(),
    evidenceId: z.string().uuid().nullable(),
    sourceRunId: z.string().uuid().nullable(),
    sourceId: z.string().uuid().nullable(),
    createdBy: evidenceTaskAssigneeSchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    revision: z.number().int().positive(),
})
    .strict();
export const evidenceTaskPageSchema = cursorPageSchema
    .extend({
    items: z.array(evidenceTaskSchema),
    totalEstimate: z.number().int().nonnegative(),
})
    .strict();
export const evidenceTaskAssigneePageSchema = z.array(evidenceTaskAssigneeSchema);
//# sourceMappingURL=evidence-tasks.js.map